import { of, concat } from 'rxjs';

import { type SocketReconnectToServerMessagePayload } from '@ezugi/types';

import { configActions, socketActions, uiActions } from '../../actions';

const { socket } = socketActions;
const { config } = configActions;
const { ui } = uiActions;

/**
 * We update SERVER_URL_GAMES to the new Engine ReconnectToServer
 * that the table is being moved to and trigger the socket.moveTable action
 */
export const handleReconnectToServer = ({ ReconnectToServer }: SocketReconnectToServerMessagePayload) => concat(
  of(
    config.update({
      definitions: { SERVER_URL_GAMES: ReconnectToServer },
    }),
    // This is to prevent the tutorial from showing up again when reconnecting
    ui.set({
      showTutorial: false,
    })
  ),
  of(socket.moveTable())
);
